import BaseService from '../commons/BaseService';
import { INonfungiblePositionManager__factory } from './typechain/INonfungiblePositionManager__factory';
export class PositionManagerContract extends BaseService {
    constructor(provider, positionManagerAddress) {
        super(provider, INonfungiblePositionManager__factory);
        this.positionManagerAddress = positionManagerAddress !== null && positionManagerAddress !== void 0 ? positionManagerAddress : '';
    }
    increaseLiquidityTxData({ user, increaseParams }) {
        const tx = {};
        tx.data = INonfungiblePositionManager__factory.createInterface().encodeFunctionData('increaseLiquidity', [increaseParams]);
        tx.to = this.positionManagerAddress;
        tx.from = user;
        return tx;
    }
}
//# sourceMappingURL=index.js.map